
<script>
import { mapActions, mapGetters } from 'vuex';
import InfoApi from '../api/infos';

export default {
  name: 'ErrorLogout',
  props: {
    cause: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters({ connectedAs: 'user/connectedAs' }),
    libelleErreur () {
      switch (this.cause) {
        case 'TIERS_NON_RECONNU':
          return 'Numéro de tiers non reconnu';
        default:
          return null;
      }
    },
    texteDetails () {
      switch (this.cause) {
        case 'ADHERENT_VGM':
          return 'Pour toute information, veuillez contacter votre conseiller ou votre maison de région';
        default:
          return 'Retrouvez ici prochainement votre site de commande aliments en ligne.<br>' +
            'Vous pourrez y accéder depuis votre ordinateur, téléphone mobile ou tablette 24h/24 et 7j/7.<br>' +
            'Ce site sera disponible dès février 2021.';
      }
    },
    afficherBtnMonAgrial () {
      switch (this.cause) {
        case 'ADHERENT_VGM':
          return false;
        default:
          return true;
      }
    }
  },
  methods: {
    ...mapActions({ sessionLogout: 'session/logout' }),
    logout () {
      if (this.connectedAs) {
        this.$store.dispatch('reset');
        this.$router.push({ name: 'admin.connect_as.selection_tiers' });
      } else {
        this.sessionLogout().finally(() => {
          this.$store.dispatch('reset');
          this.$router.push({ name: 'login' });
        });
      }
    },
    goMonAgrial () {
      this.loading = true;
      InfoApi.getUrlPortail().then(url => {
        window.location.href = url;
      }).finally(() => {
        this.loading = false;
      });
    }

  }
};

</script>

<template>
  <v-main>
    <v-container
      fluid
      fill-height
    >
      <v-layout
        row
        align-center
        justify-center
      >
        <div class="card">
          <v-layout column>
            <div class="logo-cnt">
              <img
                src="../assets/images/logo_cdea.png"
                class="logo mb-10"
              >
            </div>

            <v-layout raw>
              <div class="screenshot">
                <img
                  src="../assets/images/mobile-screenshot.png"
                  alt=""
                >
              </div>
              <v-layout
                column
                class="card-text"
              >
                <div class="error-infos">
                  <h1>Accès non autorisé</h1>
                  <p>Vous n'avez pas accès à l'application Commande Aliments</p>
                  <div v-if="libelleErreur">
                    Cause : {{ libelleErreur }}
                  </div>
                </div>

                <!-- eslint-disable-next-line vue/no-v-html -->
                <p v-html="texteDetails" />

                <v-btn
                  v-if="afficherBtnMonAgrial"
                  :loading="loading"
                  @click="goMonAgrial()"
                >
                  Retour sur MonAgrial
                </v-btn>
                <br>
                <v-btn
                  outlined
                  @click="logout()"
                >
                  Se déconnecter
                </v-btn>
              </v-layout>
            </v-layout>
          </v-layout>
        </div>
        <div
          v-if="!isMobile"
          class="l-spacer"
        />
      </v-layout>
    </v-container>
  </v-main>
</template>

<style lang="scss" scoped>
.logo{
  width: 300px;
  max-width: 100%;
  height: auto;
}

.layout{
  width: 100%;
}

.card{
  background-color: rgba(255,255,255,0.95);
  padding: 2em;
  border-radius: 8px;
}

.logo-cnt{
  text-align: center;
  width: 100%;
}

.card-text{
  max-width: 450px;
}
.error-infos{
  background-color: #ddd;
  padding: 0.5em 1.5em;
  margin-bottom: 2em;;
}

.screenshot{
  width: 200px;
  margin-right: 2em;
  img{
    width: 100%;
  }
}

.l-spacer{
  width: 30%;
  height: 10px;
}

.v-main {
  background-color: white;
  background-image: url('../assets/images/bg-login-desktop.png');
  background-position: top right;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .screenshot{
    display: none;
  }
  .v-main {
    background-image: url('../assets/images/bg-login-mobile.png');
    background-size: auto;
  }
}

</style>
